import * as angular from "angular";

let UpgradePlanDialogComponent = {
    selector: "vcUpgradePlanDialog",
    templateUrl:
        "/angular/components/campaign-plan/upgrade-plan-dialog.component.html",
    bindings: {
        conversionType: "=",
        reloadOnSuccess: "=?",
    },
    controller: class UpgradePlanDialogController {
        // * bindings for typescript compiler *
        public conversionType: string;
        public reloadOnSuccess?: Function;
        // ************************************

        public __env: any;

        constructor(__env: any) {
            this.__env = __env;
        }
    },
};

angular
    .module("campaignplan")
    .component(UpgradePlanDialogComponent.selector, UpgradePlanDialogComponent);
